import { EMPTY } from '@innovyze/stylovyze';
import { SensorGroupFormValues } from '@Types/sensorGroup.types';
import { FormikProps } from 'formik';
import React, { useEffect } from 'react';

interface Args {
	setSensorGroupName?: React.Dispatch<React.SetStateAction<string>>;
	setIsValid: React.Dispatch<React.SetStateAction<boolean>>;
	formikProps: FormikProps<SensorGroupFormValues>;
}

export default function usePropagateFormikDependant({
	setSensorGroupName,
	setIsValid,
	formikProps,
}: Args) {
	// Propagate name, to be used in the PageWrapper
	useEffect(() => {
		if (setSensorGroupName) {
			setSensorGroupName(formikProps?.values?.name || EMPTY);
		}
	}, [formikProps?.values?.name, setSensorGroupName]);

	// Propagate isValid, to block the submit button in the PageWrapper
	useEffect(() => {
		setIsValid(
			!formikProps.errors.name &&
				!formikProps.errors.sensorType &&
				!formikProps.errors.sensors,
		);
	}, [
		formikProps.errors.name,
		formikProps.errors.sensorType,
		formikProps.errors.sensors,
	]);
}
